module.exports = __webpack_public_path__ + "img/Introspection@3x.2a02bed4.png";